import getApiClient from '@/plugins/api-client'
import calendarEvent from '@/dto/calendarEvent'
const moment = require('moment')

export default {
    loadJobs: function() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('/jobs', {
            params: {
                'event.end[after]': 'first day of this month 00:00:00',
                status: 1
            }
        })
            .then(result => {
                let jobs = result.data['hydra:member']

                jobs.forEach(function(job) {
                    self.createCalendarItemsFromJob(job)
                })
            })
            .catch(error => {
                console.log(error)
            })
    },

    loadBusyDates() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('/busy_dates', {
            params: {
                'date[after]': 'yesterday'
            }
        })
            .then(result => {
                result.data['hydra:member'].forEach(dateObj => {
                    let calendar = self.calendars.filter(function(calendar) {
                        return (
                            moment(dateObj.date).format('MMMM') === calendar.month &&
                            moment(dateObj.date).format('YYYY') === calendar.year
                        );
                    })[0]

                    if (! calendar) {
                        calendar = self.extraCalendars.filter(function(calendar) {
                            return (
                                moment(dateObj.date).format('MMMM') === calendar.month &&
                                moment(dateObj.date).format('YYYY') === calendar.year
                            );
                        })[0]
                    }

                    if (! calendar) {
                        calendar = {
                            month: moment(dateObj.date).format('MMMM'),
                            year: moment(dateObj.date).format('YYYY'),
                            start: moment(dateObj.date).format('YYYY-MM-01'),
                            blocking: false,
                            events: []
                        }

                        self.extraCalendars.push(calendar)
                    }

                    calendar.events = calendar.events.filter(event => {
                        return event.category !== 'blocking_date'
                    })

                    let calendarEventObject = Object.assign({}, calendarEvent)
                    calendarEventObject.start = new Date(dateObj.date)
                    calendarEventObject.name = 'Data bloqueada'
                    calendarEventObject.blockedDateId = dateObj['@id']
                    calendarEventObject.category = 'busy_date'

                    calendar.events.push(calendarEventObject)
                })
            })
            .catch(error => {
                console.log(error)
            })
    },

    mountCalendars: function() {
        const self = this,
            currentMonth = moment(new Date()).format('MMMM'),
            currentYear = moment(new Date()).format('YYYY'),
            nextMonth = moment(new Date()).add('1', 'month').format('MMMM'),
            nextMonthYear = moment(new Date()).add('1', 'month').format('YYYY')

        const defaultCalendars = [
            {
                month: currentMonth,
                year: currentYear,
                start: moment(new Date()).format('YYYY-MM-01'),
                blocking: false,
                events: []
            },
            {
                month: nextMonth,
                year: nextMonthYear,
                start: moment(new Date()).add('1', 'month').format('YYYY-MM-01'),
                blocking: false,
                events: []
            }
        ]

        defaultCalendars.forEach(function(calendar) {
            self.calendars.push(calendar)
        })

    },

    createCalendarItemsFromJob: function(job) {
        const self = this

        job.event.dates.forEach(function(date) {
            if (! date.start) {
                return
            }

            let calendarEventObject = Object.assign({}, calendarEvent),
                calendar = self.calendars.filter(function(calendar) {
                    return (
                        moment(date.start).format('MMMM') === calendar.month &&
                        moment(date.start).format('YYYY') === calendar.year
                    );
                })[0]

            if (! calendar) {
                calendar = self.extraCalendars.filter(function(calendar) {
                    return (
                        moment(date.start).format('MMMM') === calendar.month &&
                        moment(date.start).format('YYYY') === calendar.year
                    );
                })[0]
            }

            if (! calendar) {
                calendar = {
                    month: moment(date.start).format('MMMM'),
                    year: moment(date.start).format('YYYY'),
                    start: moment(date.start).format('YYYY-MM-01'),
                    blocking: false,
                    events: []
                }

                self.extraCalendars.push(calendar)
            }

            calendarEventObject.start = new Date(date.start)
            calendarEventObject.startDate = date.start
            calendarEventObject.name = job.event.name
            calendarEventObject.category = 'job'
            calendarEventObject.jobId = job.id

            calendar.events.push(calendarEventObject)
        })
    },

    startBlockingCalendar(calendar) {
        calendar.blocking = true
        if (! this.currentBlockingCalendar) {
            this.currentBlockingCalendar = calendar
            if (!this.$store.state.skipDateBlockingAlert) {
                this.showBlockingAlert = true
            }
        }

        let busyDates = calendar.events.filter(event => {
            return event.category === 'busy_date'
        })

        busyDates.forEach(date => {
            date.category = 'blocking_date'
            this.datesToBlock.push(moment(date.start).format('YYYY-MM-DD'))
        })
    },

    stopBlockingCalendar(calendar) {
        calendar.blocking = false
        this.currentBlockingCalendar = null
        this.blockDates()
    },

    hideBlockingAlert() {
        this.showBlockingAlert = false
        if (this.skipBlockingAlert) {
            this.$store.commit('setSkipBlockingDateAlert', this.skipBlockingAlert)
        }
    },

    setToBlock(dateObj) {
        if (! this.datesToBlock.includes(dateObj.date) && this.currentBlockingCalendar) {
            this.datesToBlock.push(dateObj.date)

            let dateBlocked = this.currentBlockingCalendar.events.filter(date => {
                return date.date === dateObj.date
            })

            if (! dateBlocked.length) {
                let calendarEventObject = Object.assign({}, calendarEvent)
                calendarEventObject.start = dateObj.date
                calendarEventObject.name = 'Data bloqueada'
                calendarEventObject.jobId = null
                calendarEventObject.category = 'blocking_date'

                this.currentBlockingCalendar.events.push(calendarEventObject)
            }
        }
    },

    unsetToBlock(eventObj) {
        let events = this.currentBlockingCalendar?.events

        if (events) {
            this.currentBlockingCalendar.events = events.filter(event => {
                let compareDate = (typeof event.start === 'object' ? moment(event.start).format('YYYY-MM-DD') : event.start)
                return compareDate !== eventObj.date
            })

            this.datesToBlock = this.datesToBlock.filter(date => {
                return date !== eventObj.date
            })
        }
    },

    getBusyDatesFromCalendar(calendar) {
        return calendar.events.filter(event => {
            return event.category === 'busy_date'
        })
    },

    blockDates() {
        const self = this,
            api = getApiClient(self.$store),
            userId = self.$store.state.session.user.id,
            payload = {busyDates: []}

        self.datesToBlock.forEach(date => {
            payload.busyDates.push({
                date: date
            })
        })

        self.calendars.forEach(calendar => {
            let busyDates = this.getBusyDatesFromCalendar(calendar)
            busyDates.forEach(event => {
                payload.busyDates.push({
                    date: event.start,
                    id: event.blockedDateId
                })
            })
        })

        self.extraCalendars.forEach(calendar => {
            let busyDates = this.getBusyDatesFromCalendar(calendar)
            busyDates.forEach(event => {
                payload.busyDates.push({
                    date: event.start,
                    id: event.blockedDateId
                })
            })
        })

        api.patch(`professional/block_dates/${userId}`, payload, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(() => {
                self.datesToBlock = []
                self.loadJobs()
                self.loadBusyDates()
            })
            .catch(error => {
                console.log(error)
            })
    }
}
